import React, { CSSProperties, useEffect, useState, useRef } from "react";
import { Tab, TabProps, Menu, Label, Icon, Button } from "semantic-ui-react";
import { useIntl } from "react-intl";

import DENController, { DENEvent } from "../DENController";
import { EncounterInfo } from "../common/EncounterInfo";

import DentalRecord1 from "./DentalRecord1";
import FaceRecord from "./FaceRecord";
import MuscleRecord from "./MuscleRecord";
import PlaqueRecord from "./PlaqueRecord";
import SoftRecord from "./SoftRecord";
import JawRecord from "./JawRecord";

type DiagramProps = {
  // function
  controller: DENController;
  onEvent: (e: DENEvent) => any;
  setProp: (context: any, keyPrefix: string, callback?: any) => {};

  masterData: any;
  sub?: string;

  // ----- Plaque Record
  patientDetail: any;
  encounterInfo?: EncounterInfo;
  // missingteeth: any[];
  implantteeth: any[];
  periodontiumRecord: any;
  periodontiumHistoryList: any[];
  filterClinicalFindingIds: any[];
  clinicalFindings?: any[];
  periodontalExamData: any;
  showDrawingChecked?: string[];
  historyReviewSubTab: number;
  // ----- end Plaque Record

  isEditDental: boolean;
  isEditMuscle: boolean;
  isEditFace: boolean;
  isEditPlaque: boolean;
  isEditSoft: boolean;
  isEditJaw: boolean;

  activeIndexDiagram: number;
  selectorMode: boolean;
  clinicalFindingId?: string | null;
  clinicalFindingIndex?: number | null;

  filterItem: any;
  setHideBabyTooth: () => void;
  hideBabyTooth: boolean;
  setSuperTooth: (toothIdSL: string, options?: { createExam?: boolean }) => void | (() => void);
  superteeth?: string[];
  setMissingTooth: (toothId: any) => void | (() => void);
  hiddenEvaluation: boolean;

  encounter?: EncounterInfo;
  encounterIndex?: number | null;

  activeEvaluation: EvaluationType | "";
};

type EvaluationType = keyof typeof MENU_EVALUATION;

// show / hide menu evaluation
const MENU_EVALUATION = {
  "Dental Diagram": false,
  "Head & Neck": true,
  "Muscle & TMJ": true,
  Periodontium: false,
  "Oral cavity": true,
  "Jaw-bones": false,
};

const Diagram = (props: DiagramProps) => {
  const intl = useIntl();

  // const [masterData, setMasterData] = useState(props.masterData)
  // const [clinicalFindings, setCinicalFindings] = useState(props.clinicalFindings)

  // useEffect(() => {
  //   const addNewKey = changeColors(props.masterData)
  //   setMasterData(addNewKey)
  // }, [props.masterData])

  // useEffect(() => {
  //   let swaplocation = props.clinicalFindings?.map(item => {
  //     let prepare
  //     prepare = item
  //     prepare.location = item.locations_name ? item.locations_name : item.location
  //     prepare.locationId = item.locations ? item.locations : null
  //     return prepare
  //   })
  //   setCinicalFindings(swaplocation)
  // }, [props.clinicalFindings])

  const changeColors = (masterData) => {
    if (masterData.clinicaltags?.items?.length > 0) {
      let prepare = Object.assign({}, masterData);
      let items = prepare.clinicaltags.items.map((item) => {
        let pre;
        pre = item;
        pre.color = item.colors ? item.colors : item.color;
        return item;
      });
      prepare.clinicaltags.items = items;
      return prepare;
    } else {
      return masterData;
    }
  };
  const masterData = changeColors(props.masterData);

  const clinicalFindings = props.clinicalFindings?.map((item) => {
    let prepare;
    prepare = item;
    prepare.location = "locations_name" in item ? item.locations_name : item.location;
    prepare.locationId = item.locations ? item.locations : null;
    return prepare;
  });

  // console.log("Diagram masterData", masterData);
  // console.log("Diagram clinicalFindings", clinicalFindings);
  // console.log("Diagram props.clinicalFindings", props.clinicalFindings);
  return (
    <div id="diagram" style={{ margin: "8px 0px" }}>
      <Tab
        className="secondary-menu-dpo"
        menu={{ secondary: true, color: "green", pointing: true }}
        activeIndex={props.activeIndexDiagram}
        onTabChange={(e: React.MouseEvent<HTMLDivElement, MouseEvent>, { activeIndex, panes }: TabProps) => {
          // setActiveIndex(data.activeIndex)

          if (activeIndex !== props.activeIndexDiagram && panes[activeIndex].menuItem.key !== "evaluation") {
            props.controller.setState({ activeIndexDiagram: activeIndex });
          }
        }}
        panes={[
          {
            menuItem: (
              <Menu.Item key="dentaldiagram">
                {intl.formatMessage({ id: "cukey64" })}{" "}
                {props.isEditDental ? (
                  <div style={{ marginLeft: "6px" }}>
                    <Icon inverted color="orange" name="check circle" />{" "}
                  </div>
                ) : null}
              </Menu.Item>
            ),
            render: () => (
              <div>
                <DentalRecord1 {...props} clinicalFindings={clinicalFindings} />
              </div>
            ),
          },
          {
            menuItem: (
              <Menu.Item key="face">
                {"Head & Neck"}
                {props.isEditFace ? (
                  <div style={{ marginLeft: "6px" }}>
                    <Icon inverted color="orange" name="check circle" />{" "}
                  </div>
                ) : null}
              </Menu.Item>
            ),
            render: () => (
              <div style={diagramStyle}>
                <FaceRecord {...props} clinicalFindings={clinicalFindings} masterData={masterData} />
              </div>
            ),
          },
          {
            menuItem: (
              <Menu.Item key="muscle">
                {intl.formatMessage({ id: "cukey126" })}{" "}
                {props.isEditMuscle ? (
                  <div style={{ marginLeft: "6px" }}>
                    <Icon inverted color="orange" name="check circle" />{" "}
                  </div>
                ) : null}
              </Menu.Item>
            ),
            render: () => (
              <div style={diagramStyle}>
                <MuscleRecord {...props} clinicalFindings={clinicalFindings} masterData={masterData} />
              </div>
            ),
          },
          {
            menuItem: (
              <Menu.Item key="plaque">
                {intl.formatMessage({ id: "cukey157" })}{" "}
                {props.isEditPlaque ? (
                  <div style={{ marginLeft: "6px" }}>
                    <Icon inverted color="orange" name="check circle" />{" "}
                  </div>
                ) : null}
              </Menu.Item>
            ),
            render: () => (
              <div style={diagramStyle}>
                <PlaqueRecord
                  // function
                  onEvent={props.onEvent}
                  setProp={props.setProp}
                  // data
                  patientDetail={props.patientDetail}
                  encounterInfo={props.encounterInfo}
                  missingteeth={props.missingteeth}
                  partialmissingteeth={props.partialmissingteeth}
                  periodontiumRecord={
                    props.sub !== "DiagnosisHistory"
                      ? props.periodontiumRecord
                      : props.sub === "DiagnosisHistory" && props.historyReviewSubTab === 0
                      ? props.historyVisitPeriodontiumRecord
                      : props.sub === "DiagnosisHistory" && props.historyReviewSubTab === 1
                      ? props.historyPeriodontiumRecord
                      : props.sub === "DiagnosisHistory" && props.historyReviewSubTab === 2
                      ? props.historyTreatmentPeriodontiumRecord
                      : props.sub === "TreatmentHistory"
                      ? props.periodontiumRecord
                      : null
                  }
                  // periodontiumRecord={props.sub === "DiagnosisHistory" ? props.historyPeriodontiumRecord : props.periodontiumRecord}
                  periodontiumHistoryList={props.periodontiumHistoryList}
                  periodontalExamData={props.periodontalExamData}
                  clinicalFindings={clinicalFindings}
                  filterClinicalFindingIds={props.filterClinicalFindingIds}
                  showDrawingChecked={props.showDrawingChecked}
                  sub={props.sub}
                  historyReviewSubTab={props.historyReviewSubTab}
                  hiddenEvaluation={props.hiddenEvaluation}
                />
              </div>
            ),
          },
          {
            menuItem: (
              <Menu.Item key="soft">
                {intl.formatMessage({ id: "cukey141" })}{" "}
                {props.isEditSoft ? (
                  <div style={{ marginLeft: "6px" }}>
                    <Icon inverted color="orange" name="check circle" />{" "}
                  </div>
                ) : null}
              </Menu.Item>
            ),
            render: () => (
              <div style={diagramStyle}>
                <SoftRecord {...props} clinicalFindings={clinicalFindings} masterData={masterData} />
              </div>
            ),
          },
          {
            menuItem: (
              <Menu.Item key="jaw">
                {intl.formatMessage({ id: "cukey103" })}{" "}
                {props.isEditJaw ? (
                  <div style={{ marginLeft: "6px" }}>
                    <Icon inverted color="orange" name="check circle" />{" "}
                  </div>
                ) : null}
              </Menu.Item>
            ),
            render: () => (
              <div style={diagramStyle}>
                <JawRecord {...props} clinicalFindings={clinicalFindings} masterData={masterData} />
              </div>
            ),
          },
          ...(MENU_EVALUATION[Object.keys(MENU_EVALUATION)?.[props.activeIndexDiagram]] && !props.hiddenEvaluation
            ? [
                {
                  menuItem: (
                    <Menu.Item
                      key="evaluation"
                      className={"button-evaluation " + props.sub}
                      active={false}
                      style={{ padding: 0, marginLeft: "17em", marginBottom: "3px", border: 0 }}
                    >
                      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <div
                          onClick={() => {
                            // setOpenPhysicalExam(true)
                            props.setProp("activeEvaluation", Object.keys(MENU_EVALUATION)?.[props.activeIndexDiagram]);
                          }}
                        >
                          <Button disabled={props.selectorMode} circular icon style={{ color: "white", backgroundColor: "brown" }}>
                            <Icon name="list" />
                          </Button>
                          <span style={{ color: "#4f4f4f", paddingLeft: "3px" }}>{intl.formatMessage({ id: "cukey75" })}</span>
                        </div>
                      </div>
                    </Menu.Item>
                  ),
                },
              ]
            : []),
        ]}
      />
    </div>
  );
};

export default React.memo(Diagram);

export const diagramStyle: CSSProperties = {
  display: "flex",
  width: "100%",
  minHeight: "200px",
  textAlign: "center",
  justifyContent: "center",
};
